import "./index.css";
import { CircularProgress } from "@material-ui/core";

const Loading = ({ size = 20 }) => {
  return <CircularProgress size={`${size}px`} />;
};

export default Loading;
